import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import relativeTime from "dayjs/plugin/relativeTime";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

/**
 * Global dayjs plugin registration. ~15 pages call `.fromNow()` and used to
 * depend on whichever eagerly-imported page happened to register the plugin
 * first — route-level code splitting removed that accidental ordering, so
 * the plugins are registered here, once, before anything renders (imported
 * by src/index.tsx and the vitest setup).
 */
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime);
// `ll` / `lll` / `LLL`: dates in the dashboard language's own order
// ("Oct 16, 2026", "16 oct 2026", "2026年10月16日").
dayjs.extend(localizedFormat);
